import type { ReactNode, JSX } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';

export interface FormInputGroupProps
    extends CommonProps,
        VariantProps<typeof FormInputGroupStyles> {
    children: ReactNode;
    errorClassName?: string;
    hasErrors?: boolean;
    errorMessage?: string;
}

export const FormInputGroupStyles = tv({
    slots: {
        root: 'group relative flex flex-col gap-2',
        error: 'text-sm flex gap-2 text-danger-500 before:font-bold before:pt-0.5 before:text-xs before:shrink-0 before:content-["!"] before:bg-danger-500 before:rounded-full before:w-5 before:inline-block before:text-black before:text-center',
    },
});

export const FormInputGroup = ({
    className,
    children,
    errorClassName,
    hasErrors,
    errorMessage,
    testId = 'form-input-group',
}: FormInputGroupProps): JSX.Element => {
    const { root, error } = FormInputGroupStyles();
    return (
        <div className={root({ className })} data-testid={testId}>
            {children}
            {hasErrors && (
                <span className={error({ className: errorClassName })}>
                    {errorMessage}
                </span>
            )}
        </div>
    );
};
